import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import SideMenu from 'components/SideMenu';
import ArmyGotTalent from 'pages/soldier/armyGotTalent'
import ArmyLife from 'pages/soldier/armyLife'
import Documentary from 'pages/soldier/documentary'
import ElegantDemeanour from 'pages/soldier/elegantDemeanour'
import MostBeautiful from 'pages/soldier/mostBeautiful'
import "./index.css";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      dataList: [
        {
          txt: "退役军人风采",
          type: 1,
          component: ElegantDemeanour,
          path: '/entrance/soldier/elegantDemeanour'
        },
        {
          txt: "最美退役军人",
          type: 2,
          component: MostBeautiful,
          path: '/entrance/soldier/mostBeautiful'
        },
        {
          txt: "精彩纪录片",
          type: 3,
          component: Documentary,
          path: '/entrance/soldier/documentary'
        },
        {
          txt: "军队达人",
          type: 4,
          component: ArmyGotTalent,
          path: '/entrance/soldier/armyGotTalent'
        },
        {
          txt: "军队生活",
          type: 4,
          component: ArmyLife,
          path: '/entrance/soldier/armyLife'
        }
      ],
    }

  }




  render() {
    const { active } = this.state;
    return (
      <div className="container clear" style={{ marginTop: '40px'}}>
        <SideMenu title={'军旅文化'} data={this.state.dataList} tabListWidth={140} />
        <div className="soldier_content_right">
          {
            this.state.dataList.map((item, index) => {
              return (
                <Route path={item.path} component={item.component} key={index} />
              )
            })
          }
          {/* <Redirect from="/entrance/soldier" to="/entrance/soldier/elegantDemeanour" /> */}
        </div>
      </div>
    )
  }
}